<template>
    <basic-container id="exminetopic20211118" style=" padding-bottom:0px !important;">
      <avue-crud v-if="reWrite"
                 :option="option"
                 :table-loading="loading"
                 :data="data"
                 :search.sync="search"
                 :page.sync="page"
                 :permission="permissionList"
                 ref="crud"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @selection-change="selectionChange"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @on-load="onLoad"
                 @refresh-change="onLoad"
      >
            <template slot="menuLeft">
              <Form ref="form" @onLoad="onLoad" :projectId="search.projectId"></Form>
            </template>
            
            <template slot="menu" slot-scope="scope">
                <el-button 
                          type="text"
                          size="small"
                          @click="handleView(scope.row)">查 看

                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          v-if="scope.row.status==1"
                          @click="handleEdit(scope.row)">编 辑

                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          v-if="scope.row.status==1"
                          @click="handleStop(scope.row)">停 用

                </el-button>
                <el-button 
                          type="text"
                          size="small"
                          @click="rowDel(scope.row)">删 除

                </el-button>
            </template>
        </avue-crud>

    </basic-container>
</template>

<script>
    import { getList, removeAssess,stopAssess} from "@/api/crmedical/examine/examinetopic";
    import {mapGetters} from "vuex";
    import {getProjectList} from "@/api/crmedical/project/project";
    import Form from "./examinetopic-form.vue";
    import { setStore } from '@/util/store';
    export default {
        components:{
          Form
        },
        data() {
            return {
                search:{
                },
                
                query: {status:1},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                reWrite: false,
                tempProjectId: '',
                projectList:[],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 24,
                    border: true,
                    index: true,
                    selection: false,
                    align:"left",
                    dialogClickModal: false,
                    columnBtn:true,
                    addBtn:false,
                    viewBtn:false,
                    editBtn:false,
                    delBtn:false,
                    stripe:true,
                    column: [
                      {
                        label: "项目名称",
                        prop: "projectId",
                        type: 'tree',
                        cascaderItem: ['objectType'],
                        searchClearable:false,
                        editDisabled:true,
                        search: true,
                        props: { label: 'name', value: 'id' },
                        searchPlaceholder:"请选择 项目名称",
                        rules: [{
                          required: true,
                          message: "请选择项目名称",
                          trigger: "change"
                        }]
                      },
                      {
                        label: "考核对象",
                        prop: "objectType",
                        type: "select",
                        search: true,
                        searchPlaceholder:"请选择 考核对象",
                        dataType: 'string',
                        hide:true,
                        showColumn:false,
                        dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
                        props: {
                          label: "dictValue",
                          value: "dictKey",
                        },
                        rules: [{
                          required: true,
                          message: "请选择考核对象",
                          trigger: "blur"
                        }]
                      },
                      {
                          label: "考核对象",
                          prop: "assessObjectName",
                      },
                      
                      {
                          label: "标准名称",
                          search: true,
                          span: 24,
                          prop: "name",
                          searchPlaceholder:"请输入 标准名称",
                          rules: [{
                              required: true,
                              message: "请输入考核标准内容",
                              trigger: "change"
                          }]
                      },
                      {
                          label: "总分",
                          prop: "totalScore",
                      },
                      {
                          label: "基准分",
                          prop: "baseScore",
                      },
                      {
                          label: "合同名称",
                          prop: "contractName",
                      },
                      {
                          label: "合同编号",
                          prop: "contractCode",
                      },
                      {
                          label: "状态",
                          search: true,
                          type:"select",
                          searchPlaceholder:"请选择 状态",
                          span: 24,
                          prop: "status",
                          dicData:[{label:'启用',value:1,},{label:'停用',value:0,},],
                          props:{
                            label:"label",
                            value:"value"
                          },
                        
                      },
                                
                                
                    ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.examinetopic_add, true),
                    viewBtn: this.vaildData(this.permission.examinetopic_view, true),
                    delBtn: this.vaildData(this.permission.examinetopic_delete, true),
                    editBtn: this.vaildData(this.permission.examinetopic_edit, true)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        watch:{
          "search.projectId"(val){
            this.tempProjectId = val;
          }
        },
        created() {
          //加载列表
          getProjectList({}).then((res) => {

            this.projectList = res.data;
            this.findObject(
                  this.option.column,
                  'projectId'
                ).dicData = this.projectList;
            setStore({
              name: 'projectList',
              content: this.projectList
            })
            setStore({
              name: 'firstProject',
              content: this.projectList[0]?this.projectList[0].id:""
            })
            this.search.projectId = this.projectList[0].id;
            if (this.projectList.length > 0) {
              this.query.projectId = this.projectList[0].id;
              this.search.projectId = this.projectList[0].id;
              this.tempProjectId = this.projectList[0].id;
            }
            this.$nextTick(() => {
              this.reWrite = true;
              setTimeout(()=>{
              console.log(this.$refs.crud)
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                console.log(1212121)
                    if(this.option.height == this.bodyHeight - 398){
                      this.option.height = this.bodyHeight - 284
                    }else{
                      this.option.height = this.bodyHeight - 398;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });

          });
        },
        methods: {
          // 停用
          handleStop(row){
              this.$confirm("此操作将停用该标准，是否继续？", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
              })
              .then(() => {
                  return stopAssess({id: row.id});
              })
              .then(() => {
                  this.onLoad();
                  this.$message.success('操作成功!');
              });
          },

          // 查看
          handleView(row){
            this.$refs.form.openDialog('view',row)
          },
          // 编辑
          handleEdit(row){
            this.$refs.form.openDialog('edit',row)
          },
          // 行删除
          rowDel(row) {
                this.$confirm("此操作将删除该标准，是否继续?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return removeAssess({ids: row.id});
                })
                .then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                });
          },
            
          // 清空
          searchReset() {
            console.log(this.search)
            this.search.objectType = "";
            this.search.projectId = this.tempProjectId
            this.query.projectId = this.tempProjectId;
            this.query.objectType = '';
            this.query.name = '';
            this.query.status = "";
            this.onLoad();
          },
          searchChange(params, done) {
            this.query = params;
            console.log(params)
            this.page.currentPage = 1;
            this.onLoad();
            done();
          },
          selectionChange(list) {
            this.selectionList = list;
          },
          selectionClear() {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
          },
          currentChange(currentPage) {
            this.page.currentPage = currentPage;
          },
          sizeChange(pageSize) {
            this.page.pageSize = pageSize;
          },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
            if (!this.query.projectId ) {
              this.query.projectId = this.tempProjectId;
            }
            
            getList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
            });
          }
        },
        mounted(){
          this.option.height = this.bodyHeight - 398;
          // setTimeout(()=>{
            
          //   document.querySelector("#exminetopic20211118 > div > div > div > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)").addEventListener("click", ()=>{
          //       if(this.option.height == this.bodyHeight - 398){
          //         this.option.height = this.bodyHeight - 298
          //       }else{
          //         this.option.height = this.bodyHeight - 398;
          //       }
          //   });
          // })
          

        }
    };
</script>

<style lang="scss">
#exminetopic20211118{
  .avue-form__menu--center{
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
}



</style>


